module.exports = __webpack_public_path__ + "static/img/12.7740140.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/4/zh/12.png
// module id = ZLbN
// module chunks = 0